import { CSSProperties } from 'react';
import { Flex, FlexProps } from 'styled-system/jsx';

/**
 * Shared page backdrop — team review #19: the uniform 24px grid read as
 * template styling; replaced with the late-V1 gradient look — canvas black
 * with two faint top glows (brand green left, violet right) fading out by
 * ~60% viewport height. Values stay <6% alpha so content contrast is
 * untouched. Single source of truth for the LVUSD / LVMON / Earn / Airdrop /
 * Competition / Leaderboard / Portfolio / Privacy Pools pages.
 *
 * Apply directly to a page's root element via `style={pageBackgroundStyle}`,
 * or use the `<PageBackground>` wrapper for new pages.
 */
export const pageBackgroundStyle: CSSProperties = {
  background: '#0a0b0a',
  backgroundImage: [
    'radial-gradient(1100px 540px at 16% -10%, rgba(199, 245, 13, 0.055), transparent 62%)',
    'radial-gradient(900px 480px at 86% -14%, rgba(110, 84, 255, 0.05), transparent 60%)',
  ].join(', '),
  backgroundRepeat: 'no-repeat, no-repeat',
  backgroundAttachment: 'fixed, fixed',
};

export const PageBackground = ({ children, style, ...props }: FlexProps) => (
  <Flex
    direction="column"
    minH="100vh"
    style={{ ...pageBackgroundStyle, ...style }}
    {...props}
  >
    {children}
  </Flex>
);
